import { CommonGet, CommonPost } from "../../../utils/CommonFetch";


export default {
    SaveCustomerBiometrics,
    getGroups,
    UpdateCustomerBiometrics,
    getGroups,
    getAllOperationEntitiesForDropDown,
    GetCustomerDetails,
    getBiometrics,
    RemoveCustomerBiometrics,
    GetCollectionPointsFilter,
    saveCustomer,
    GetCollectionPoints,
    UpdateCustomerBiometricIsDefault,
    GetCollectionCategoryByOperationEntityID,
    GetCollectionPointsByCollectionCategoryID,
    getFactoriesByGroupID,
    GetCustomerDetailsByCustomerID,
    updateCustomer,
    getCustomerByID

};

async function SaveCustomerBiometrics(pictures, customerID, isDefault){
    let customerBiometrics = {
        CustomerID: customerID,
        customerBiometricData: pictures,
        CustomerBiometricDataTypeID: 1,
        isDefault: isDefault,
        isActive: true,
        CreatedBy: 0,
        CreatedDate: new Date().toISOString(),
        ModifiedBy: 0,
        ModifiedDate: new Date().toISOString(),
    }
    const response = await CommonPost('/api/CustomerBiometrics/SaveCustomerBiometrics', null, customerBiometrics);
    return response;
}


async function UpdateCustomerBiometrics(data) {

    const response = await CommonPost('/api/CustomerBiometric/UpdateCustomerBiometrics', null, data);
    return response;
}
async function GetCustomerDetails(customerBiometrics){

    customerBiometrics.groupID = parseInt(customerBiometrics.groupID);
    customerBiometrics.operationEntityId = parseInt(customerBiometrics.operationEntityId);

    const response = await CommonPost('/api/Customer/FilterCustomer', null, customerBiometrics);
    return response.data;
}
async function getGroups() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    for (let item of Object.entries(response.data)) {
        if(item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"];
        }
    }
    return groupArray;
}
async function getAllOperationEntitiesForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllOperationEntities', null);
    for (let item of Object.entries(response.data)) {
        if (item[1]["groupID"] === parseInt(id) && item[1]["isActive"] === true)
            operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function getBiometrics(id,typeId){
    let filtermodel = {
        CustomerID: id,
        CustomerBiometricDataTypeID: typeId,

    }
    const response = await CommonPost('/api/CustomerBiometrics/GetCustomerBiometricsById', null, filtermodel);

    return response.data;
}

async function RemoveCustomerBiometrics(id, userId) {

    const response = await CommonGet('/api/CustomerBiometrics/RemoveCustomerBiometrics', 'customerBiometricID=' + id + '&modifiedBy=' + userId);
    return response;
}

async function GetCollectionPointsFilter(id) {
    var collectionPointArray = [];
    var response = await CommonGet('/api/Card/GetCollectionPointsFilter', null);
    for (let item of Object.entries(response.data)) {
        if (item[1] !== undefined && item[1]["operationEntityID"] === parseInt(id) )
            collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"];
    }
    return collectionPointArray;
}


async function GetCollectionCategoryByOperationEntityID(id) {
    var collectionCategoryArray = [];
    const response = await CommonGet('/api/CollectionCategory/GetCollectionCategoryByOperationEntityID', 'operationEntityID=' + id);
    for (let item of Object.entries(response.data)) {
        if(item[1]["isActive"] === true) {
            collectionCategoryArray[item[1]["collectionCategoryID"]] = item[1]["collectionCategoryName"]
        }
    }
    return collectionCategoryArray;
}

async function GetCollectionPointsByCollectionCategoryID(id) {
    var collectionPointArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetCollectionPointsByCollectionCategory', 'collectionCategoryID=' + id);
    for (let item of Object.entries(response.data)) {
        if(item[1]) {
            collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"];
        }
    }
    return collectionPointArray;
}

async function getFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/OperationEntity/GetFactoriesByGroupID','groupID=' + groupID);
    let array = []
    for (let item of Object.entries(response.data)) {
        if (item[1]) {
            array[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return array;
}
async function GetCustomerDetailsByCustomerID(customerID){
    const response = await CommonGet('/api/Customer/GetCustomerDetailsByCustomerID','customerID=' + customerID);
    return response.data;
}



async function saveCustomer(customerDetails) {

    let customerInformation = {
        groupID: customerDetails.groupID,
        operationEntityID: customerDetails.operationEntityID,
        collectionPointID: customerDetails.collectionPointID,
        collectionCatagoryID: customerDetails.collectionCatagoryID,
        customers: [
            {
                customerCode: customerDetails.customerCode,
                title: customerDetails.title,
                firstName: customerDetails.firstName,
                secondName: customerDetails.secondName,
                lastName: customerDetails.lastName,
                gender: customerDetails.gender,
                dateOfBirth: customerDetails.dateOfBirth,
                nic: customerDetails.nic,
                address1: customerDetails.address1,
                address2: customerDetails.address2,
                address3: customerDetails.address3,
                city: customerDetails.city,
                countryCode: customerDetails.countryCode,
                homePhoneNo: customerDetails.homePhoneNo,
                officePhoneNo: customerDetails.officePhoneNo,
                mobileNo: customerDetails.mobileNo,
                email: customerDetails.email,
                question: customerDetails.question,
                answer: customerDetails.answer,
                isSupplementary: customerDetails.isSupplementary ? '1' : '0',
                registrationNumber: customerDetails.registrationNumber,
                nameToBePrinted: customerDetails.nameToBePrinted,
                language: customerDetails.language
            }
        ]
    }
    const response = await CommonPost('/api/Card/CardUpload', null, customerInformation);
    return response;
}

async function updateCustomer(customerDetails) {
    let customerInformation = {
        customerID: customerDetails.customerID,
        customerCode: customerDetails.customerCode,
        title: customerDetails.title,
        firstName: customerDetails.firstName,
        secondName: customerDetails.secondName,
        lastName: customerDetails.lastName,
        gender: customerDetails.gender,
        dateOfBirth: customerDetails.dateOfBirth,
        nic: customerDetails.nic,
        address1: customerDetails.address1,
        address2: customerDetails.address2,
        address3: customerDetails.address3,
        city: customerDetails.city,
        countryCode: customerDetails.countryCode,
        homePhoneNo: customerDetails.homePhoneNo,
        officePhoneNo: customerDetails.officePhoneNo,
        mobileNo: customerDetails.mobileNo,
        email: customerDetails.email,
        question: customerDetails.question,
        answer: customerDetails.answer,
        isSupplementary: customerDetails.isSupplementary,
        nameToBePrinted: customerDetails.nameToBePrinted,
        language: customerDetails.language
    }
    const response = await CommonPost('/api/Card/CustomerUpdate', null, customerInformation);
    return response;
}

async function GetCollectionPoints(operationEntityID) {
    var collectionPointArray = [];
    var response = await CommonGet('/api/CollectionPoint/GetCollectionPointsForCustomerUpload', 'operationEntityID=' + operationEntityID);
    for (let item of Object.entries(response.data)) {
        collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"];
    }

    return collectionPointArray;
}


async function UpdateCustomerBiometricIsDefault( oldCustomerBiometricID, newCustomerBiometricID){
    const response =
        await CommonGet('/api/CustomerBiometrics/UpdateCustomerBiometricIsDefault', 'oldCustomerBiometricID=' + oldCustomerBiometricID + '&newCustomerBiometricID=' + newCustomerBiometricID);
    return response;
}

async function getCustomerByID(customerID) {

    var response = await CommonGet('/api/Customer/GetCustomerByID', 'customerID=' + parseInt(customerID));
    return response.data;
}

